import React from 'react'

function UpMap() {
  return (
    <div></div>
  )
}

export default UpMap